import {
  PrivacyBottomBannerFields,
  PrivacyBottomBannerProps,
} from "../types/PrivacyBottomBanner.types";
import { StringField } from "../../../types/types";

export class PrivacyBottomBannerModel {
  private readonly fields?: PrivacyBottomBannerFields;

  constructor(props: PrivacyBottomBannerProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }

  get subtitle(): StringField | undefined {
    return this.fields?.SubTitle
  }
}
